export enum SidebarNavItemTypes {Analytics, Explorer, Inbox}

export enum SidebarFooterItemTypes {Toggle, Support, PrivacyPolicy,TermsOfUse,Logout}
